import React, { Component } from 'react';
import { showInfo } from '@/components';
import styled from 'styled-components';
const Span = styled.span `
  cursor: pointer;
  :hover {
    color: #1890ff;
  }
`;
class Check extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (e) => {
            const { checked } = this.props;
            this.props.onChange({ label: e.target.value, checked: !checked });
        };
        this.onDetail = () => {
            const { item } = this.props;
            showInfo('buyer', item.value);
        };
    }
    render() {
        const { item, checked } = this.props;
        return (<div className="ant-checkbox-group-item">
                <span className={`${checked ? 'ant-checkbox-checked' : ''} ant-checkbox`} style={{ width: '16px', height: '16px' }} onChange={this.onChange}>
                    <input type="checkbox" className="ant-checkbox-input" value={item.value}/>
                    <span className="ant-checkbox-inner"/>
                </span>
                <Span onClick={this.onDetail}>{item.label}</Span>
            </div>);
    }
}
export default Check;
